import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { LaunchpadCard } from 'src/components/ui/LaunchpadCard';
import { isSmallMobileDeviceQuery } from 'src/util/responsive';
import { object, string } from 'yup';
import { IssueStartDatePicker } from '../atomic-components/IssueStartDatePicker';
import { IssueEndDatePicker } from '../atomic-components/IssueEndDatePicker';
import { IssueFundingFloorPercentageField } from '../atomic-components/IssueFundingFloorPercentageField';
import { AssetTypeConditional } from '../../user/AssetTypeConditional';
import { TotalConstructionVolumeField } from '../atomic-components/TotalConstructionVolumeField';
import { TotalConstructionVolumeNoteField } from '../atomic-components/TotalConstructionVolumeNoteField';
import { PublicFundingField } from '../atomic-components/PublicFundingField';
import { PublicFundingNoteField } from '../atomic-components/PublicFundingNoteField';
import { BrokerageFeeForEndCustomersCheckbox } from '../atomic-components/BrokerageFeeForEndCustomersCheckbox';
import { YieldNumberField } from '../atomic-components/YieldNumberField';
import { YieldIntroductoryTextField } from '../atomic-components/YieldIntroductoryTextField';
import { YieldInfoIconTextField } from '../atomic-components/YieldInfoIconTextField';
import { YieldFieldNameTextField } from '../atomic-components/YieldFieldNameTextField';
import { InvestedToDateField } from '../atomic-components/InvestedToDateField';

export const validationSchemaIssuingDetails = object({
  startDateIssue: string(),
  endDateIssue: string(),
  fundingFloor: string(),
});

interface Props {
  disabled: boolean;
}

export const IssuingDetails: FC<Props> = ({ disabled }) => {
  const isSmallMobileDevice = useMediaQuery(isSmallMobileDeviceQuery);
  const { t } = useTranslation();
  return (
    <LaunchpadCard title={t('dashboard.assets.addedit.investment.issuingdetails.title')}>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: isSmallMobileDevice ? '1fr' : '1fr 1fr',
          columnGap: isSmallMobileDevice ? 'unset' : '24px',
        }}
      >
        <IssueStartDatePicker />
        <IssueFundingFloorPercentageField disabled={disabled} />
        <IssueEndDatePicker />
        <AssetTypeConditional supported={['builderOwnerModel']}>
          <TotalConstructionVolumeField />
          <InvestedToDateField />
          <TotalConstructionVolumeNoteField />
          <PublicFundingField />
          <PublicFundingNoteField />
          <BrokerageFeeForEndCustomersCheckbox />
          <YieldNumberField />
          <YieldIntroductoryTextField />
          <YieldFieldNameTextField />
          <YieldInfoIconTextField />
        </AssetTypeConditional>
      </div>
    </LaunchpadCard>
  );
};
